import { Placeholder, ProductPlaceholder } from '@/components';
import style from './CollectionPlaceholder.module.scss';
import classNames from 'classnames';

const CollectionPlaceholder = () => {
  const isProductCardLargImage =
    process?.env?.NEXT_PUBLIC_FEATURE_FLAG_PRODUCT_LARGE_IMAGE ?? false;
  return (
    <div className={style.placeholder__product_container}>
      <div
        className={classNames(style.placeholder__product_list, {
          [style.placeholder__product_list_card_large]: isProductCardLargImage,
        })}
      >
        {new Array(24).fill(null).map((_, index) => (
          <ProductPlaceholder
            className={style.placeholder_product}
            key={index}
          />
        ))}
      </div>
      <div className={style.placeholder__pagination}>
        <Placeholder className={style.placeholder__actions} />
        <ul className={style.placeholder__container_pages}>
          {new Array(5).fill(null).map((_, index) => (
            <Placeholder className={style.placeholder__page} key={index} />
          ))}
        </ul>
        <Placeholder className={style.placeholder__actions} />
      </div>
    </div>
  );
};

export { CollectionPlaceholder };
